import { headers } from "../../../App/Axios"
import HTTPService from "../../../App/HTTPService"

export const newestMemberGetRequest = () => {
    return HTTPService.get("/newestmembers/", headers)
}
